<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 :fullscreen="$vuetify.breakpoint.xsOnly" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('add_to_segment') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider

    v-card-text
      .text-center.mt-16(v-if="isLoading")
        v-progress-circular.ml-3(:width="2" :size="50" color="primary400" indeterminate)
      .pb-16(v-else)
        .text-md.mt-8 {{ $t('choose_segment_add_customers') }}:
        yc-select.mt-4(label="Choose segments" :items="segments" v-model="firstSegment" :noDataText="$t('no_segments_available')")
    .pb-16
    v-divider

    v-card-actions.py-4.px-6
      v-spacer
      v-btn.button-md.primary400--text(@click="showDialog = false" text) {{ $t('cancel') }}
      v-btn.button-md.white--text(@click="confirm" :loading="isSaving" color="info500" depressed :disabled="!firstSegment") {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['open', 'customers'],
  data: () => ({
    isLoading: true,
    isSaving: false,
    segments: [],
    selectedSegments: [],
    rules: {
      not_empty: [v => v.trim().length || 'This field is required'],
      not_empty_array: [v => !!(v && v.length) || 'This field is required']
    },
    firstSegment: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    otherSegments () {
      if (this.firstSegment) {
        return this.segments.filter(item => item.id !== this.firstSegment)
      }
      return this.segments
    }
  },
  mounted () {
    this.fetchSegments()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchSegments () {
      this.isLoading = true
      this.$axios.get(`/connect/${this.company.slug}/groups?page_size=-1`)
        .then(resp => {
          this.segments = resp.data.results.map(item => {
            item.label = item.title
            return item
          })
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    addMoreSegment () {
      const item = {
        id: Date().toString(),
        assignee: null
      }
      this.selectedSegments.push(item)
    },
    removeSegment (assignee) {
      this.selectedSegments = this.selectedSegments.filter(x => x.id !== assignee.id)
    },
    confirm () {
      const selectedSegment = this.segments.find(item => item.id === this.firstSegment)
      if (selectedSegment) {
        this.isSaving = true
        const selectedCustomers = this.customers.map(item => item.id)
        const prevCustomers = selectedSegment.customer || []
        const ids = [...new Set([...selectedCustomers, ...prevCustomers])]
        this.$axios.patch(`/connect/${this.company.slug}/groups/${selectedSegment.id}/`, { customer: ids })
          .then(resp => {
            this.showMessage(['success', this.$t('success_message.customer_added_segment_successfully')])
            this.$emit('success', resp.data)
            this.showDialog = false
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_add_customer_segment')])
          })
          .finally(() => {
            this.isSaving = false
          })
      }
    }
  }
}
</script>